export const CHECKOUT_PATH = "checkouts";
